module.exports = __webpack_public_path__ + "img/mercedesme-logo@2x.e1e0dcee.webp";